import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/api.service';
import 'src/assets/js/sp.min.js';
declare var $:any;
@Component({
  selector: 'app-book',
  templateUrl: './book.component.html',
  styleUrls: ['./book.component.scss']
})
export class BookComponent implements OnInit {
  bookContent: any [] = [
    {
      title: '',
    }
  ];
  bContent:any;
  newBookList: any;
  bImages: any = [];
  url = this.api.url;
  constructor(private api: ApiService, private route: ActivatedRoute, private el: ElementRef) {
  }

  ngOnInit(): void {
    this.GetBookDetails(this.route.snapshot.paramMap.get('id'));
    this.GetNewBookList();
  }
  ngAfterViewInit() {
    window.onmousewheel = (e) => {
      const ev = e || window.event;
    };
    this.el.nativeElement.querySelector('#scrollX')
      .addEventListener('mousewheel', (e: any) => {
          e = e || window.event;
          const delta = Math.max(-1, Math.min(1, (e.wheelDelta || -e.detail)));
          this.el.nativeElement.querySelector('#scrollX').scrollLeft -= (delta * 40);
          e.preventDefault();
      }
    );
  }
  GetBookDetails(id: any) {
    this.api.GetBookDetails(id).subscribe(
      data => {
        this.bookContent = data;
        this.bContent = data[0].bookIntroduction.replace(/<[^>]+>/g,"").replace(/&nbsp;/ig, "");
        this.bImages = data[0].detailsImages;
        if(data[0].detailsImages.length == 0) {
          this.bImages = [
            {
              path: data[0].bookCover
            }
          ]
        }
      }
    );
    setTimeout( ()=>{
      $('#spWrap').smoothproducts();
    },300)
  }
  GetNewBookList() {
    this.api.GetNewBookList().subscribe(
      data => this.newBookList = data
    )
  }
}
